import './Radio.scss'

// Define the checkbox component props interface
type RadioProps = React.InputHTMLAttributes<HTMLInputElement>

export const Radio: React.FC<RadioProps> = (props) => {
  return (
    <label className="CLRadio">
      <input className="CLRadio__input" type="radio" {...props} />
      <span className="CLRadio__check"></span>
    </label>
  )
}
